/* custom-header.js
   Handles mobile toggles and accessible keyboard opening/closing
*/

document.addEventListener('DOMContentLoaded', function () {
  // Mobile: toggle mega panels when summary is clicked (or control button)
  document.querySelectorAll('.header__menu-item--has-mega > .header__mega-toggle').forEach(toggle => {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      const wrapper = this.closest('.header__menu-item--has-mega');
      wrapper.classList.toggle('open');
      wrapper.querySelector('.header__mega')?.classList.toggle('open');
    });
  });

  // Category accordion toggles on mobile
  document.querySelectorAll('.header__mega-category h4').forEach(h4 => {
    h4.addEventListener('click', function (e) {
      const parent = this.closest('.header__mega-category');
      parent.classList.toggle('open');
    });
  });

  // Close mega when pressing Escape
  document.addEventListener('keyup', function(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      document.querySelectorAll('.header__menu-item--has-mega.open').forEach(el => {
        el.classList.remove('open');
        el.querySelector('.header__mega')?.classList.remove('open');
      });
    }
  });

  // Ensure keyboard focus opens the mega panel (accessibility)
  document.querySelectorAll('.header__menu-item--has-mega > a, .header__menu-item--has-mega > .header__mega-toggle').forEach(el => {
    el.addEventListener('focus', function() {
      const wrapper = this.closest('.header__menu-item--has-mega');
      wrapper && wrapper.classList.add('open');
      const mega = wrapper && wrapper.querySelector('.header__mega');
      mega && mega.classList.add('open');
    });

    el.addEventListener('blur', function() {
      setTimeout(() => { // small timeout to allow focus to move to panel
        const wrapper = this.closest('.header__menu-item--has-mega');
        if (!wrapper) return;
        if (!wrapper.contains(document.activeElement)) {
          wrapper.classList.remove('open');
          wrapper.querySelector('.header__mega')?.classList.remove('open');
        }
      }, 150);
    });
  });
});
